import 'css-chunksrc/client/scenes/projectExpenseCreation/form/expenseTypeSelect/expenseTypeIcon/styles.scss';export default {
  "tag": "_tag_1eij1_1",
  "expenseIcon": "_expenseIcon_1eij1_13",
  "closedTag": "_closedTag_1eij1_19",
  "icon": "_icon_1eij1_30",
  "light": "_light_1eij1_43"
};